import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

interface LoadingProps {
  size?: string | number;
  fullScreen?: boolean;
}

export function Loading({ size = '90px', fullScreen }: LoadingProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: fullScreen ? '100vw' : '100%',
        height: fullScreen ? '100vh' : '100%',
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
}
